import { render, staticRenderFns } from "./GoogleLogin.vue?vue&type=template&id=5869ac53&scoped=true"
import script from "./GoogleLogin.vue?vue&type=script&lang=js"
export * from "./GoogleLogin.vue?vue&type=script&lang=js"
import style0 from "./GoogleLogin.vue?vue&type=style&index=0&id=5869ac53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5869ac53",
  null
  
)

export default component.exports